import { DataCellProps } from '../types';

export const TenantCreatorCell = ({ _customRowProps, tenant }: DataCellProps) => {
  return <div>{tenant.creator}</div>;
};
